import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

const DeliveryUnitRulesCopy = ({ deliveryUnit, deliveryUnitOfMeasure, className }) => {
  const isPair = deliveryUnitOfMeasure === 'PAIR';
  const isPairOrEach = deliveryUnitOfMeasure === 'EACH' || isPair;
  const copyId = isPairOrEach ? 'pdp.deliveryUnit.multiples.copy' : 'pdp.deliveryUnit.increments.copy';
  const count = isPairOrEach
    ? deliveryUnit
    : // Example: PPPK5000 -> 5000 && PPK06 -> 6
      parseInt(deliveryUnitOfMeasure.replace(/PPK/, ''), 10);

  return (
    <div className={className}>
      <TranslatedCopy id={copyId} values={{ count }} />
      <br />
      {isPair && <TranslatedCopy id='pdp.deliveryUnit.pair.copy' />}
    </div>
  );
};

DeliveryUnitRulesCopy.defaultProps = {
  className: null
};

DeliveryUnitRulesCopy.propTypes = {
  className: PropTypes.string,
  deliveryUnit: PropTypes.number.isRequired,
  deliveryUnitOfMeasure: PropTypes.string.isRequired
};

export default DeliveryUnitRulesCopy;
